import { useEffect } from 'react';
import { useMap, useMapEvents } from 'react-leaflet';
import { Position } from '../../types';

interface MapControllerProps {
  targetPosition: Position | null;
  zoom?: number;
  onMapClick?: () => void;
}

const MapController: React.FC<MapControllerProps> = ({ targetPosition, zoom = 18, onMapClick }) => {
  const map = useMap();

  useMapEvents({
    click() {
      if (onMapClick) {
        onMapClick();
      }
    },
  });

  useEffect(() => {
    if (targetPosition) {
      map.flyTo(targetPosition, zoom, {
        duration: 1.5,
      });
    }
  }, [targetPosition, zoom, map]);

  return null;
};

export default MapController;
